export class LoanInvoice {
  /**
   * @param {number} id
   * @param {string} trxType
   * @param {number} profileId
   * @param {string} profileName
   * @param {string} concept
   * @param {number} amount
   * @param {string} pdfFile
   * @param {string} pdfXml
   * @param {string} trxConfirmationDate
   */
  constructor(
    id,
    trxType,
    profileId,
    profileName,
    concept,
    amount,
    pdfFile,
    pdfXml,
    trxConfirmationDate
  ) {
    this.id = id;
    this.trxType = trxType;
    this.profileId = profileId;
    this.profileName = profileName;
    this.concept = concept;
    this.amount = amount;
    this.pdfFile = pdfFile;
    this.pdfXml = pdfXml;
    this.trxConfirmationDate = trxConfirmationDate;
  }
}
